import React, { Component } from "react";
import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import { Redirect, Route, Switch } from "react-router";
import NewTenantContract from "./New";
import RenewTenantContract from "./Renew";
import TerminateTenantContract from "./Terminate";
import TenantContractContextWrapper from "@eres/ejari-core/contexts/TenantContractContext";
import TerminateSuccess from "./Terminate/TerminateSuccess";
import SubmitSuccess from "./New/SubmitSuccess";
import RenewSuccess from "./Renew/RenewSuccess";

class TenantContract extends Component<RoutedViewProps> {
	render() {
		const pp = this.props.match.url;
		return <TenantContractContextWrapper>
			<Switch>
				<Route path={ pp + "/new/success" } component={ SubmitSuccess }/>
				<Route path={ pp + "/new" } component={ NewTenantContract }/>
				<Route path={ pp + "/renew/success" } component={ RenewSuccess }/>
				<Route path={ pp + "/renew" } component={ RenewTenantContract }/>
				<Route path={ pp + "/terminate/success" } component={ TerminateSuccess }/>
				<Route path={ pp + "/terminate" } component={ TerminateTenantContract }/>
				<Route path={ pp } exact={ true }>
					<Redirect to={ pp + "/new" }/>
				</Route>
			</Switch>
		</TenantContractContextWrapper>;
	}
}

export default TenantContract;
